import React,{useState} from 'react';
import MultiImageManager from '../common/MultiImageManager';

const CustomizationPhotoUpload=({
  userId,
  sellerId,
  offeringId,
  groupId,
  images,
  onImagesChange
})=>{
  const [isOpen,setIsOpen]=useState(false);
  const photoCount=images?.length || 0;

  return (
    <div onClick={(event)=>event.stopPropagation()}>
      <button
        type="button"
        aria-expanded={isOpen}
        onClick={()=>setIsOpen((current)=>!current)}
        className="flex w-full items-center justify-between rounded-xl border border-indigo-100 bg-white px-4 py-3 text-left text-xs font-bold text-indigo-700 transition hover:border-indigo-300 hover:bg-indigo-50"
      >
        <span>Upload sample photos</span>
        {photoCount>0 && (
          <span className="ml-3 text-[10px] font-semibold text-slate-500">
            {photoCount} added
          </span>
        )}
      </button>

      {isOpen && (
        <div className="mt-4">
          <MultiImageManager
            images={images || []}
            maxImages={3}
            onImagesChange={onImagesChange}
            path={`users/${userId}/order-customizations/${sellerId}/${offeringId}/${groupId}`}
            label="Reference photos"
            aspect={1}
            idealSize="800x800"
          />
        </div>
      )}
    </div>
  );
};

export default CustomizationPhotoUpload;
